import React from "react";
import ProductModal from "../../components/Modal/ProductModal";
import HeaderFour from "../../components/Header/HeaderFour";
import ShopSidebarMain from "./ShopSidebarMain";
import Footer from "../../components/Footer";

const ShopSidebar = () => {
  return (
    <>
      <ProductModal />

      <HeaderFour />

      <ShopSidebarMain />

      <Footer />
    </>
  );
};

export default ShopSidebar;
